import Link from '@mui/material/Link';
import Alert from '@mui/material/Alert';
import Container from '@mui/material/Container';
import AlertTitle from '@mui/material/AlertTitle';
import Typography from '@mui/material/Typography';

import { useTranslate } from 'src/locales';
import { CONFIG } from 'src/global-config';
import { buildSupportMailtoUrl } from 'src/lib/buildSupportMailToUrl';

export function View500() {
  const { t } = useTranslate('common');

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 12,
      }}
    >
      <Alert
        severity="error"
        sx={{
          width: '100%',
          mb: 3,
          '& .MuiAlert-message': {
            width: '100%',
          },
        }}
      >
        <AlertTitle sx={{ fontSize: '1.25rem', fontWeight: 600 }}>
          {t('errors.serverError.title')}
        </AlertTitle>

        <Typography variant="body2" sx={{ mb: 1 }}>
          {t('errors.serverError.description')}
        </Typography>

        <Typography variant="body2">
          {t('errors.serverError.supportMessage')}{' '}
          <Link href={buildSupportMailtoUrl()} underline="always">
            {CONFIG.supportEmail}
          </Link>
        </Typography>
      </Alert>
    </Container>
  );
}
